export const api_endpoint = process.env.REACT_APP_API_ENDPOINT;
export const movie_endpoint = process.env.REACT_APP_MOVIE_ENDPOINT;
export const asset_endpoint = process.env.REACT_APP_ASSET_ENDPOINT;
export const recaptcha_site_key = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const dougu_url = process.env.REACT_APP_DOUGU_URL;
export const google_analytics_code = process.env.REACT_APP_GOOGLE_ANALYTICS_CODE;